import type { IconData } from '@stacksjs/iconify-core'

export const otherUiSkull: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 .16a7.35 7.35 0 0 0-3.43 13.852v1.828h10.78V7.51A7.35 7.35 0 0 0 8 .16m5.635 9.8a1.225 1.225 0 1 1-2.45 0a1.225 1.225 0 0 1 2.45 0M7.51 11.185a1.225 1.225 0 1 0 0-2.45a1.225 1.225 0 0 0 0 2.45\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiSkull
